import React, { useState } from 'react';

import { LoadingDataReducerStateType } from 'client/reducers/loadingData';
import { getChartColor } from 'client/utils/color';
import {
    barChartTickFFormatter as barChartTickFormatter,
    getAliceAppYAxisLabelProps,
    getChartStateLabel,
    getTickFormat,
} from 'client/utils/monitoring';
import {
    Bar,
    BarChart,
    CartesianGrid,
    Legend,
    ReferenceArea,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts';

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any[];
    labels: string[];
    dataLoadingState: LoadingDataReducerStateType;
    yAxisLabel?: string;
    yAxisDomain?: [number | string, number | string];
}

export const AliceAppMonitoringPageBarChart: React.FC<Props> = ({
    data,
    labels,
    dataLoadingState,
    yAxisLabel,
    yAxisDomain,
}) => {
    const [hiddenLabels, setHiddenLabels] = useState<string[]>([]);

    const showChartStatus = ['loading', 'error'].includes(dataLoadingState);

    const format = getTickFormat(data[0].from, data[data.length - 1].to);

    return (
        <ResponsiveContainer width="100%" height={300}>
            <BarChart data={data}>
                <XAxis dataKey="label" tickFormatter={(tick) => barChartTickFormatter(tick, format)} minTickGap={30} />
                <YAxis label={yAxisLabel && getAliceAppYAxisLabelProps(yAxisLabel)} domain={yAxisDomain} />
                <Legend
                    onClick={({ value, inactive }) => {
                        inactive
                            ? setHiddenLabels(hiddenLabels.filter((x) => x !== value))
                            : setHiddenLabels([...hiddenLabels, value]);
                    }}
                />
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <Tooltip isAnimationActive={false} />
                {labels.map((label, i) => {
                    return (
                        <Bar
                            key={i}
                            dataKey={label}
                            stroke={getChartColor(label)}
                            fill={getChartColor(label)}
                            stackId="stackId"
                            hide={hiddenLabels.includes(label)}
                            isAnimationActive={false}
                        />
                    );
                })}
                {showChartStatus && (
                    <ReferenceArea
                        y1={0}
                        strokeWidth={0}
                        fill="#ccc"
                        fillOpacity={0.2}
                        isFront
                        {...{ label: getChartStateLabel(dataLoadingState as 'loading' | 'error') }}
                    />
                )}
            </BarChart>
        </ResponsiveContainer>
    );
};
